
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, IconButton, Box, Chip } from '@mui/material';
import { Brightness4, Brightness7, Settings } from '@mui/icons-material';
import { TaskContext } from '../contexts/TaskContext';
import { ThemeContext } from '../contexts/ThemeContext';
import packageJson from '../../package.json';

const Header = () => {
  const { selectedTask, finishSelectedTask, clearSelectedTask } = useContext(TaskContext);
  const { darkMode, toggleDarkMode } = useContext(ThemeContext);

  return (
    <AppBar position="static" sx={{ bgcolor: '#424242' }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
          <Typography variant="h6" component="div">
            Time Logger
          </Typography>
          <Chip 
            label={`v${packageJson.version}`}
            size="small"
            variant="outlined"
            sx={{ 
              color: 'white', 
              borderColor: 'white', 
              fontSize: '0.75rem',
              height: '20px'
            }}
          />
        </Box>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {selectedTask && (
            <>
              <Box
                sx={{
                  px: 2,
                  py: 0.5,
                  borderRadius: 1,
                  border: 1,
                  borderColor: 'primary.main',
                  color: 'inherit',
                  display: 'flex',
                  alignItems: 'center',
                  minHeight: '32px'
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                  Current: {selectedTask.name}
                </Typography>
              </Box>
              <Button 
                color="secondary" 
                variant="contained" 
                onClick={finishSelectedTask}
                size="small"
              >
                Finish
              </Button>
              <Button 
                color="inherit" 
                onClick={clearSelectedTask}
                size="small"
              >
                Clear
              </Button>
            </>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Button color="inherit" component={Link} to="/">
            Timer
          </Button>
          <Button color="inherit" component={Link} to="/pomodoro">
            Pomodoro
          </Button>
          <Button color="inherit" component={Link} to="/todo">
            Todo
          </Button>
          <Button color="inherit" component={Link} to="/stats">
            Stats
          </Button>
          <Button color="inherit" component={Link} to="/settings">
            <Settings />
          </Button>
          <IconButton color="inherit" onClick={toggleDarkMode}>
            {darkMode ? <Brightness7 /> : <Brightness4 />}
          </IconButton>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
